// Components/Common/Loader.jsx
import React from "react";

const Loader = () => {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "18px"
    }}>
      Loading theme...
    </div>
  );
};

export default Loader;
